import { CheckCircle } from 'lucide-react';

type OnboardingProgressProps = {
  currentStep: number;
  totalSteps?: number;
};

const OnboardingProgress = ({ currentStep, totalSteps = 3 }: OnboardingProgressProps) => {
  const steps = totalSteps === 2 
    ? [
        { number: 1, label: 'Role' },
        { number: 2, label: 'Skills' }
      ]
    : [
        { number: 1, label: 'Role' },
        { number: 2, label: 'Team' },
        { number: 3, label: 'Skills' }
      ];

  return (
    <div className="flex justify-around mb-8">
      {steps.map((step) => (
        <div key={step.number} className="flex flex-col items-center">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
            step.number < currentStep ? 'bg-primary text-primary-foreground' :
            step.number === currentStep ? 'bg-primary/20 text-primary border-2 border-primary' :
            'bg-muted text-muted-foreground'
          }`}>
            {step.number < currentStep ? <CheckCircle size={18} /> : step.number}
          </div>
          <span className="text-xs mt-2 text-muted-foreground">
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default OnboardingProgress;
